export default serviceWorkerPath => {
  if ('serviceWorker' in navigator) {
    let forceReload = false;
    navigator.serviceWorker.addEventListener('message', event => {
      const { data } = event;

      if (data && data.type === 'versionCheck') {
        if (data.version !== 3) {
          forceReload = true;
        }
      }
    });

    const swRegistration = navigator.serviceWorker.register(serviceWorkerPath, {
      updateViaCache: 'imports',
    });

    return {
      swRegistration,
      onLocationChangeWrapper: cb => (...args) => {
        if (forceReload) {
          window.location.reload();
          return;
        }

        cb(...args);
      },
    };
  }

  return {
    swRegistration: Promise.reject(),
    onLocationChangeWrapper: cb => cb,
  };
};
